module.exports = __webpack_public_path__ + "img/dsci0139.dd81a4c1.jpg";